// import React from 'react';

// function ProjectDashboard() {
 
//  const powerBiUrl = process.env.REACT_APP_Proj_Dashboard;
//  //console.log("Project Dashboard",powerBiUrl)
//   // const powerBiUrl = process.env.REACT_APP_Project_Dashboard;
//   // const powerBiUrl = "https://app.powerbi.com/view?r=eyJrIjoiODZjNDU4YWQtMThmMC00NWQyLWFlZTgtN2M1MGU1MjkxZTc3IiwidCI6ImIxNjFjODk3LTBhZTItNDJhMC1iZTg2LThmN2UzNmYyMDQ5ZiJ9";
//   return (
    
//       <iframe  title="Power BI Report"  src={powerBiUrl}  sandbox="allow-scripts allow-same-origin allow-forms allow-popups" allowFullScreen></iframe>
    
//   );
// }

// export default  ProjectDashboard;

import React,{ useEffect, useState } from 'react';
import { queuedApiFetch } from '../api';

function ProjectDashboard() {
    const [powerBiUrl, setPowerBiUrl] = useState('');
    const url_name = 'Proj_Dashboard';
    const projectDetails = localStorage.getItem("projectDetails");
    const selectedProjectDetail = projectDetails ? JSON.parse(projectDetails) : null;
    const projectName = selectedProjectDetail?.projectName?.trim() || "";

    useEffect(() => {
        const fetchData = async () => {
            try {
                const requestOptions = { method: 'GET' };
                const data = await queuedApiFetch(
                    `/project/get_powerbi_url?url_name=${url_name}`,
                    requestOptions
                );

                if (
                    data?.apistatus?.Status_Code === 200 &&
                    data?.apistatus?.Status_Description?.toLowerCase() === 'success'
                ) {
                    const proj_dash_url = `${data.data}&filter=T_master_project/Proj_Name%20eq%20%27${projectName}%27&filterPaneEnabled=false&navContentPaneEnabled=false%22`;
                    setPowerBiUrl(proj_dash_url);
                    // setPowerBiUrl(data.data); 
                } else {
                    console.error('Failed to load Power BI URL');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        fetchData();
    }, []);


    return (

        <iframe title="Power BI Report" src={powerBiUrl} sandbox="allow-scripts allow-same-origin allow-forms allow-popups" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

    );
}

export default ProjectDashboard;
